import React from "react";
import styled from "styled-components";

const StyledUl = styled.ul`
  &&& {
    margin: 20px 250px 0;
    padding: 15px;
    height: 100px;
    overflow-y: scroll;
    background-color: #fff;
    text-align: left;
  }

  li {
    font-size: 13px;
    line-height: 19px;
  }

  label {
    margin-right: 3px;
  }
`;

const ResultWrapUl = ({ children }) => {
  return (
    <StyledUl>
      <div>{children}</div>
    </StyledUl>
  );
};

export default ResultWrapUl;
